import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import ParticlesBackground from './ParticlesBackground';
import AppNavbar from './Navbar';
import './Momentum.css';

const API_URL = process.env.REACT_APP_API_URL || '';

const Momentum = () => {
    const { isAuthenticated, loading, error, setError, login } = useAuth();
    const [localEmail, setLocalEmail] = useState("");
    const [loadedCount, setLoadedCount] = useState(0);

    const handleIframeLoad = () => {
        setLoadedCount(prev => prev + 1);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        await login(localEmail);
    };

    // Tickers to display in order
    const tickers = ['TQQQ', 'SPY', 'QQQ', 'SMH', 'SOXL', 'SPX', 'TLT', 'IWM'];

    if (loading) {
        return (
            <div className="momentum-page">
                <header className="momentum-header">
                    <AppNavbar />
                    <ParticlesBackground />
                    <div className="header-content">
                        <h1>Momentum</h1>
                    </div>
                </header>

                <main className="momentum-main">
                    <div className="container">
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                            <p>Loading...</p>
                        </div>
                    </div>
                </main>

                <footer className="momentum-footer">
                    <div className="container">
                        <p>&copy; 2023-{new Date().getFullYear()} machinaquanta.com. All rights reserved.</p>
                    </div>
                </footer>
            </div>
        );
    }

    if (!isAuthenticated) {
        return (
            <div className="momentum-page">
                <header className="momentum-header">
                    <AppNavbar />
                    <ParticlesBackground />
                    <div className="header-content">
                        <h1>Momentum</h1>
                    </div>
                </header>

                <main className="momentum-main">
                    <div className="container">
                        <div className="momentum-login-container">
                            {/* Blurred preview */}
                            <div className="momentum-blurred-preview">
                                <div className="momentum-chart-card">
                                    <h3>Momentum Analysis</h3>
                                    <div style={{ minHeight: '600px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <p style={{ textAlign: 'center', color: '#666' }}>
                                            Premium content - login required
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Login overlay */}
                            <div className="momentum-login-overlay">
                                <h2>Subscriber Login</h2>
                                <p>Enter your email to access the site.</p>
                                <form onSubmit={handleSubmit}>
                                    <input
                                        type="email"
                                        placeholder="Enter your email"
                                        value={localEmail}
                                        onChange={(e) => setLocalEmail(e.target.value)}
                                        required
                                    />
                                    <button type="submit">Login</button>
                                </form>
                                {error && <p className="error-message">{error}</p>}

                                <iframe
                                    src="https://machinaquanta.substack.com/embed"
                                    title="Substack Subscription Login"
                                    width="480"
                                    height="320"
                                    frameBorder="0"
                                    scrolling="no"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </main>

                <footer className="momentum-footer">
                    <div className="container">
                        <p>&copy; 2023-{new Date().getFullYear()} machinaquanta.com. All rights reserved.</p>
                    </div>
                </footer>
            </div>
        );
    }

    // Authenticated view - display all ticker charts via iframes
    return (
        <div className="momentum-page">
            <header className="momentum-header">
                <AppNavbar />
                <ParticlesBackground />
                <div className="header-content">
                    <h1>Momentum</h1>
                </div>
            </header>

            <main className="momentum-main">
                <div className="container">
                    {/* Shared legend — shown once above all charts */}
                    <div className="momentum-legend">
                        <span className="momentum-legend-item">
                            <span className="momentum-legend-swatch" style={{ background: 'rgb(0,191,255)' }}></span>
                            Bullish Anomaly
                        </span>
                        <span className="momentum-legend-item">
                            <span className="momentum-legend-swatch" style={{ background: 'rgb(220,20,60)' }}></span>
                            Bearish Anomaly
                        </span>
                        <span className="momentum-legend-item">
                            <span className="momentum-legend-swatch" style={{ background: 'rgb(65,105,225)' }}></span>
                            Call Premium
                        </span>
                        <span className="momentum-legend-item">
                            <span className="momentum-legend-swatch" style={{ background: 'rgb(220,20,60)', opacity: 0.6 }}></span>
                            Put Premium
                        </span>
                    </div>

                    <div className="momentum-chart-grid">
                        {tickers.map((ticker, index) => (
                            <div key={ticker} className="momentum-chart-card">
                                <h3>{ticker}</h3>
                                {index <= loadedCount ? (
                                    <iframe
                                        src={`${API_URL}/data/momentum/${ticker}/chart`}
                                        title={`${ticker} Momentum Chart`}
                                        className="momentum-iframe"
                                        scrolling="no"
                                        onLoad={handleIframeLoad}
                                    />
                                ) : (
                                    <div className="momentum-loading">
                                        Loading...
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </main>

            <footer className="momentum-footer">
                <div className="container">
                    <p>&copy; 2023-{new Date().getFullYear()} machinaquanta.com. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default Momentum;
